// extracted by mini-css-extract-plugin
export default {"trend-chart":"styles-module__trend-chart___d3ry6"};